import React from 'react';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PlusSolidIcon(props) {
  return <FontAwesomeIcon icon={faPlus} {...props} />;
}
